var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ui.errorflag)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.$t(_vm.ui.feedback)))]):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[(_vm.ui.successflag)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.successMessage))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }